import { render, staticRenderFns } from "./SalesClosuresForm.vue?vue&type=template&id=6240385e"
import script from "./SalesClosuresForm.vue?vue&type=script&lang=js"
export * from "./SalesClosuresForm.vue?vue&type=script&lang=js"
import style0 from "./SalesClosuresForm.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports